/**
 * Extracts the list of notifiable users (manager + consultants) from claim group data.
 * Used by AddClaimGroupToCompanyPage and NewCompanySelectClaimsPage before showing
 * the NotifyClaimUsersModal.
 *
 * @param {Object} options
 * @param {string|number} options.adminId - The admin_id from the claim group
 * @param {Array} options.consultantsAttributes - Array of { id, name, email, role } from the claim group
 * @param {Array} options.admins - Array of admin users to look up the manager by ID
 * @param {Array} options.managers - Array of manager users to look up the manager by ID
 * @returns {Array} Array of { id, name, email } objects
 */
export const getNotifiableUsers = _ref => {
  let {
    adminId,
    consultantsAttributes = [],
    admins = [],
    managers = []
  } = _ref;
  const users = [];
  if (adminId) {
    const admin = [...admins, ...managers].find(a => a.id === +adminId);
    if (admin) users.push({
      id: admin.id,
      name: admin.name,
      email: admin.email
    });
  }
  consultantsAttributes.forEach(c => {
    if (c.id && !users.find(u => u.id === c.id)) {
      users.push({
        id: c.id,
        name: c.name,
        email: c.email
      });
    }
  });
  return users;
};